import React, { useEffect, useState } from 'react'
import _ from 'lodash'
import { useIntl } from 'react-intl'
import CompaniesService from '../../../../services/companies/companies.service'
import UsersService from '../../../../services/users/users.service'
import { ACTIVITY_TYPES } from '../../../../utils/constants/activityTypes'
import { ZONES } from '../../../../utils/constants/zones'
import LabeledDropdown from '../../../../components/common/form-components/labeled-dropdown/LabeledDropdown'
import LabeledCheckbox from '../../../../components/common/form-components/labeled-checkbox/LabeledCheckbox'
import LabeledText from '../../../../components/common/form-components/labeled-inputs/LabeledText'
import useInputs from '../../../../utils/hooks/useInputs'
import CenterService from '../../../../services/centers/center.service'
import CenterSettingsService from '../../../../services/settings/centers/centerSettings.service'

import './centerForm.scss'
import DeleteButton from '../../../../components/common/buttons/DeleteButton'
import SaveButton from '../../../../components/common/buttons/SaveButton'
import swalAlert from '../../../../utils/helpers/swalAlert'
import { AppModalContent } from '../../../../component/layout/AppModal'
import AppButton from '../../../../component/common/AppButton'
import EntityDropdown from '../../../../component/form/EntityDropdown'
import { Group, Stack } from '@mantine/core'
import AppCheckbox from '../../../../component/form/AppCheckbox'

const CenterTechnicsAspiratorForm = ({
  centerId,
  selectedItem,
  close,
  updateInputs: updateTechnicsInputs,
}) => {
  const { formatMessage: msg } = useIntl()

  const [aspiratorTypes, setAspiratorTypes] = useState()

  const { inputs, onChangeInputs, updateInputs } = useInputs()

  useEffect(() => {
    getAspiratorTypes()
  }, [])

  useEffect(() => {
    updateInputs(selectedItem)
    // if(selectedItem)
  }, [selectedItem])

  const getAspiratorTypes = async () => {
    const response = await CenterSettingsService.aspiratorTypes.getAll({})
    if (response) {
      setAspiratorTypes(response.resp)
    }
  }

  const handleSave = async () => {
    // console.log('handleSave')
    if (centerId && centerId !== 'undefined' && !selectedItem) {
      const data = {
        ...inputs,
      }
      const response = await CenterService?.technics?.aspirators?.create({
        id: centerId,
        body: data,
      })
      // console.log('response', response)
      if (response) {
        updateTechnicsInputs(response?.resp)
        close()
      }
    }
  }

  const handleRemove = async () => {
    if (selectedItem?._id) {
      const response = await CenterService?.technics?.aspirators?.remove({
        id: centerId,
        rowId: selectedItem?._id,
      })
      if (response) {
        updateTechnicsInputs(response?.resp)
        close()
        swalAlert('success', msg({ id: 'center.technics.track.removed' }))
      } else {
        swalAlert('error', msg({ id: 'center.technics.track.error' }))
      }
    }
  }

  return (
    <AppModalContent
      buttons={[
        selectedItem && (
          <DeleteButton
            btnClass="btn-remove-modal"
            // isDisabled={!validateForm}
            onClick={handleRemove}
          />
        ),
        <AppButton preset="save" onClick={handleSave} />,
      ]}
      content={
        <Stack w="100%">
          <Group>
            <EntityDropdown
              icon="technics"
              label="aspiratorType"
              withAsterisk
              name="aspiratorTypesId"
              value={inputs?.aspiratorTypesId}
              onChange={onChangeInputs}
              options={aspiratorTypes}
            />
          </Group>
          <Group>
            <AppCheckbox
              size="lg"
              label="hyprocash"
              name="hyprocash"
              checked={inputs?.hyprocash}
              onChange={onChangeInputs}
            />
            <AppCheckbox
              size="lg"
              label="stopAndGo"
              name="stopAndGo"
              checked={inputs?.stopAndGo}
              onChange={onChangeInputs}
            />
          </Group>

          <div className="wrapper-flex">
            <div className="modal-btn-container wrapper-flex"></div>
          </div>
        </Stack>
      }
    />
  )
}

export default CenterTechnicsAspiratorForm
